var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUs(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "28px",
    height: "20px",
    viewBox: "0 0 28 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "flags / US") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "path-1",
    x: 0,
    y: 0,
    width: 28,
    height: 20,
    rx: 2
  }), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "0%",
    x2: "50%",
    y2: "100%",
    id: "linearGradient-3"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFFFF",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F0F0F0",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M10,6.66666667 C10.3681898,6.66666667 10.6666667,6.9651435 10.6666667,7.33333333 C10.6666667,7.70152317 10.3681898,8 10,8 C9.63181017,8 9.33333333,7.70152317 9.33333333,7.33333333 C9.33333333,6.9651435 9.63181017,6.66666667 10,6.66666667 Z M7.33333333,6.66666667 C7.70152317,6.66666667 8,6.9651435 8,7.33333333 C8,7.70152317 7.70152317,8 7.33333333,8 C6.9651435,8 6.66666667,7.70152317 6.66666667,7.33333333 C6.66666667,6.9651435 6.9651435,6.66666667 7.33333333,6.66666667 Z M4.66666667,6.66666667 C5.0348565,6.66666667 5.33333333,6.9651435 5.33333333,7.33333333 C5.33333333,7.70152317 5.0348565,8 4.66666667,8 C4.29847683,8 4,7.70152317 4,7.33333333 C4,6.9651435 4.29847683,6.66666667 4.66666667,6.66666667 Z M2,6.66666667 C2.36818983,6.66666667 2.66666667,6.9651435 2.66666667,7.33333333 C2.66666667,7.70152317 2.36818983,8 2,8 C1.63181017,8 1.33333333,7.70152317 1.33333333,7.33333333 C1.33333333,6.9651435 1.63181017,6.66666667 2,6.66666667 Z M3.33333333,5.33333333 C3.70152317,5.33333333 4,5.63181017 4,6 C4,6.36818983 3.70152317,6.66666667 3.33333333,6.66666667 C2.9651435,6.66666667 2.66666667,6.36818983 2.66666667,6 C2.66666667,5.63181017 2.9651435,5.33333333 3.33333333,5.33333333 Z M6,5.33333333 C6.36818983,5.33333333 6.66666667,5.63181017 6.66666667,6 C6.66666667,6.36818983 6.36818983,6.66666667 6,6.66666667 C5.63181017,6.66666667 5.33333333,6.36818983 5.33333333,6 C5.33333333,5.63181017 5.63181017,5.33333333 6,5.33333333 Z M8.66666667,5.33333333 C9.0348565,5.33333333 9.33333333,5.63181017 9.33333333,6 C9.33333333,6.36818983 9.0348565,6.66666667 8.66666667,6.66666667 C8.29847683,6.66666667 8,6.36818983 8,6 C8,5.63181017 8.29847683,5.33333333 8.66666667,5.33333333 Z M10,4 C10.3681898,4 10.6666667,4.29847683 10.6666667,4.66666667 C10.6666667,5.0348565 10.3681898,5.33333333 10,5.33333333 C9.63181017,5.33333333 9.33333333,5.0348565 9.33333333,4.66666667 C9.33333333,4.29847683 9.63181017,4 10,4 Z M7.33333333,4 C7.70152317,4 8,4.29847683 8,4.66666667 C8,5.0348565 7.70152317,5.33333333 7.33333333,5.33333333 C6.9651435,5.33333333 6.66666667,5.0348565 6.66666667,4.66666667 C6.66666667,4.29847683 6.9651435,4 7.33333333,4 Z M4.66666667,4 C5.0348565,4 5.33333333,4.29847683 5.33333333,4.66666667 C5.33333333,5.0348565 5.0348565,5.33333333 4.66666667,5.33333333 C4.29847683,5.33333333 4,5.0348565 4,4.66666667 C4,4.29847683 4.29847683,4 4.66666667,4 Z M2,4 C2.36818983,4 2.66666667,4.29847683 2.66666667,4.66666667 C2.66666667,5.0348565 2.36818983,5.33333333 2,5.33333333 C1.63181017,5.33333333 1.33333333,5.0348565 1.33333333,4.66666667 C1.33333333,4.29847683 1.63181017,4 2,4 Z M3.33333333,2.66666667 C3.70152317,2.66666667 4,2.9651435 4,3.33333333 C4,3.70152317 3.70152317,4 3.33333333,4 C2.9651435,4 2.66666667,3.70152317 2.66666667,3.33333333 C2.66666667,2.9651435 2.9651435,2.66666667 3.33333333,2.66666667 Z M6,2.66666667 C6.36818983,2.66666667 6.66666667,2.9651435 6.66666667,3.33333333 C6.66666667,3.70152317 6.36818983,4 6,4 C5.63181017,4 5.33333333,3.70152317 5.33333333,3.33333333 C5.33333333,2.9651435 5.63181017,2.66666667 6,2.66666667 Z M8.66666667,2.66666667 C9.0348565,2.66666667 9.33333333,2.9651435 9.33333333,3.33333333 C9.33333333,3.70152317 9.0348565,4 8.66666667,4 C8.29847683,4 8,3.70152317 8,3.33333333 C8,2.9651435 8.29847683,2.66666667 8.66666667,2.66666667 Z M2,1.33333333 C2.36818983,1.33333333 2.66666667,1.63181017 2.66666667,2 C2.66666667,2.36818983 2.36818983,2.66666667 2,2.66666667 C1.63181017,2.66666667 1.33333333,2.36818983 1.33333333,2 C1.33333333,1.63181017 1.63181017,1.33333333 2,1.33333333 Z M4.66666667,1.33333333 C5.0348565,1.33333333 5.33333333,1.63181017 5.33333333,2 C5.33333333,2.36818983 5.0348565,2.66666667 4.66666667,2.66666667 C4.29847683,2.66666667 4,2.36818983 4,2 C4,1.63181017 4.29847683,1.33333333 4.66666667,1.33333333 Z M7.33333333,1.33333333 C7.70152317,1.33333333 8,1.63181017 8,2 C8,2.36818983 7.70152317,2.66666667 7.33333333,2.66666667 C6.9651435,2.66666667 6.66666667,2.36818983 6.66666667,2 C6.66666667,1.63181017 6.9651435,1.33333333 7.33333333,1.33333333 Z M10,1.33333333 C10.3681898,1.33333333 10.6666667,1.63181017 10.6666667,2 C10.6666667,2.36818983 10.3681898,2.66666667 10,2.66666667 C9.63181017,2.66666667 9.33333333,2.36818983 9.33333333,2 C9.33333333,1.63181017 9.63181017,1.33333333 10,1.33333333 Z",
    id: "path-4"
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-5.4%",
    y: "-7.5%",
    width: "110.7%",
    height: "130.0%",
    filterUnits: "objectBoundingBox",
    id: "filter-5"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 1,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.06 0",
    type: "matrix",
    in: "shadowOffsetOuter1"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "flags-/-US",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Mask",
    fill: "#FFFFFF",
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28,18.6666667 L28,20 L0,20 L0,18.6666667 L28,18.6666667 Z M28,16 L28,17.3333333 L0,17.3333333 L0,16 L28,16 Z M28,13.3333333 L28,14.6666667 L0,14.6666667 L0,13.3333333 L28,13.3333333 Z M28,10.6666667 L28,12 L0,12 L0,10.6666667 L28,10.6666667 Z M28,8 L28,9.33333333 L0,9.33333333 L0,8 L28,8 Z M28,5.33333333 L28,6.66666667 L0,6.66666667 L0,5.33333333 L28,5.33333333 Z M28,2.66666667 L28,4 L0,4 L0,2.66666667 L28,2.66666667 Z M28,0 L28,1.33333333 L0,1.33333333 L0,0 L28,0 Z",
    id: "Rectangle-511",
    fill: "#D02F44",
    mask: "url(#mask-2)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-511",
    fill: "#46467F",
    mask: "url(#mask-2)",
    x: 0,
    y: 0,
    width: 12,
    height: 9.33333333
  }), /*#__PURE__*/React.createElement("g", {
    id: "Oval-43",
    mask: "url(#mask-2)"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#filter-5)",
    xlinkHref: "#path-4"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "url(#linearGradient-3)",
    fillRule: "evenodd",
    xlinkHref: "#path-4"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUs);
export default __webpack_public_path__ + "static/media/US.88e721358e84b7f64fb379538aaaaff5.svg";
export { ForwardRef as ReactComponent };